import React from 'react';
import { componentService } from 'js/services/component.service';

export const ReferFriend = React.lazy(() => import(/* webpackChunkName: "refer-friend" */ './ReferFriend'));

componentService.registerPageComponents({ referafriend: ReferFriend });
